






































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import { Listing } from '../models/Listing';
import ListingUtil from '../utils/ListingUtil';
import Defs from '../utils/Defs';

@Component
export default class PopupMultiListing extends Vue {

    public showPopup: boolean = false;
    public popup: L.Popup | null = null;
    public individualListings: Listing[] = [];

    public unsubscribe = this.$store.subscribeAction((action, state) => {

        if (action.type === 'multiListingSelectedViaMap') {
            console.log('multiListingSelectedViaMap!');
            this.onMultiListingSelected(action.payload);
        }
        if (action.type === 'listingDetailFetchComplete') {
            this.onViewDetailsModalOpen();
        }
        if (action.type === 'listingDetailFetchError') {
            this.onViewDetailsModalOpen();
        }
        if (action.type === 'closePopups') {
            this.closePopup();
        }
    });

    get map(): L.Map {
        return this.$store.state.map;
    }

    get config() {
        return this.$store.state.config;
    }

    get leftDrawerOpen() {
        return this.$store.state.leftDrawerOpen;
    }

    get isLoggedIn() {
        return this.$store.state.isLoggedIn;
    }

    get selectedListing() {
        return this.$store.state.listings.selectedListing;
    }

    get favourtiteIds() {
        return this.$store.state.favourites.favouriteIds;
    }

    public closePopup() {
        if (this.popup) {
            this.map.closePopup(this.popup);
        }

        this.showPopup = false;
    }

    public thumbnailUrl(listingPreviewImage: string) {
        return this.config.imageRoot + listingPreviewImage.replace(".jpg","_tb.jpg");
    }

    public price(listing: Listing) {
        return ListingUtil.getListingPriceBasedOnStatus(listing.st, listing.sp, listing.lpmn, listing.cl, this.isLoggedIn);
    }

    public daysOnMarket(listing: Listing) {
        return ListingUtil.getDaysOnMarket(listing.ld, listing.st, listing.fd);
    }

    public sqFootage(listing: Listing) {
        const sqFt = ListingUtil.getSqFootage(listing.tlan);
        return sqFt + ' Sq.Ft.';
    }

    public isFavourite(listing: Listing) {
        if (this.favourtiteIds.indexOf(listing.sid) !== -1) {
            return true;
        }
        return false;
    }

    public onToggleFavorite(listing: Listing) {
        if (listing) {
            if (!this.isLoggedIn) {
                this.$store.dispatch('showLoginPromptDialog', 'You must login to add to favourites.');
            } else {
                if (this.isFavourite(listing)) {
                    this.$store.dispatch('favouriteRemove',  listing.sid);
                } else {
                    this.$store.dispatch('favouriteAdd', listing.sid);
                }
            }
        }
    }

    public onViewDetails(listing: Listing) {
        console.log('onViewDetails');
        listing.viewDetailsInProgress = true;
        this.$store.dispatch('setSelectedListing', listing);
        this.$store.dispatch('sendListingEvent', {action: Defs.ANALYTICS_LISTING_MAPCLICK, sysId: listing.sid});

        this.$store.dispatch('showListingDialog');
    }

    public onViewPhotos(listing: Listing) {
        console.log('onViewPhotos');
        listing.viewPhotosInProgress = true;
        this.$store.dispatch('setSelectedListing', listing);

        if (this.isLoggedIn || listing.st !== '2') {
            this.$store.dispatch('showLightBox');
        } else {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view details of sold listings.');
        }
    }

    public onViewDetailsModalOpen() {
        console.log('onViewListingDetailsModalOpen');
        if (this.individualListings !== null) {
            for (let i = 0; i < this.individualListings.length; i++) {
                this.individualListings[i].viewDetailsInProgress = false;
            }
        }
    }

    public onListingSelected(listing: Listing) {
        console.log('onListingSelected');
        if (!this.selectedListing || listing.sid !== this.selectedListing.sid) {
            this.$store.dispatch('setSelectedListing', listing);
        }
    }

    public onMultiListingSelected(layer: L.Layer) {
        // Logger.writeLog('PopupMgr:_onMultiListingSelected');
        console.log('PopupMgr:_onMultiListingSelected');
        console.log(layer);

        // @ts-ignore - layer from LeafletMouseEvent isn't properly typed
        const rootListing: any = layer.feature;

        const individualListingsJson = JSON.parse(rootListing.properties.md);
        const forSaleListings = [];
        const pendingListings = [];
        const soldListings = [];

        for (let i = 0; i < individualListingsJson.length; i++) {
            const listing = new Listing(individualListingsJson[i]);
            listing.viewDetailsInProgress = false;
            listing.viewPhotosInProgress = false;

            if (listing.st === '1' || listing.st === '1_0') {
                forSaleListings.push(listing);
            } else if (listing.st === '3' || listing.st === '3_0') {
                pendingListings.push(listing);
            } else {
                soldListings.push(listing);
            }
        }

        this.individualListings = [];

        for (let i = 0; i < forSaleListings.length; i++) {
            this.individualListings.push(forSaleListings[i]);
        }

        for (let i = 0; i < pendingListings.length; i++) {
            this.individualListings.push(pendingListings[i]);
        }

        for (let i = 0; i < soldListings.length; i++) {
            this.individualListings.push(soldListings[i]);
        }

        this.showPopup = true; // probably not needed??

        let popupWidth = 300;
        if (this.$q.platform.is.mobile) {
            popupWidth = 275;
        }

        let lLatlng = null;
        if (rootListing.geometry.type === 'Polygon' || rootListing.geometry.type === 'MultiPolygon') {
            // @ts-ignore - no types
            lLatlng = layer.getBounds().getCenter();
        } else {
            lLatlng = L.latLng(rootListing.geometry.coordinates[1], rootListing.geometry.coordinates[0]);
        }

        this.popup = L.popup({
            className: 'multiListPopup',
            minWidth: popupWidth,
            maxWidth: popupWidth,
        })
        .setLatLng(lLatlng)
        .setContent(this.$el as HTMLElement)
        .openOn(this.map);
    }
}

